import React, { FC } from 'react';
import styles from './highlight.module.scss';

export const Highlight: FC = ({ children }) => (
  <span className={styles.container}>{children}</span>
);
